<template>
<!--  <div id="nav">-->
<!--&lt;!&ndash;    <router-link to="/">Home</router-link> |&ndash;&gt;-->
<!--&lt;!&ndash;    <router-link to="/about">About</router-link>&ndash;&gt;-->
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
<!--  </div>-->
</template>

<script>

export default {
  data(){
    return{
      isRouterAlive: true
    }
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    initStorage(){
      this.$storageUtil.initStorageMap()
    },
    init(){
      this.initStorage()
    }
  },
  mounted() {
    this.init()
  }

}


</script>
<style>
html,body,#app{
  height: 100%;
  width: 100%;
}
#app {
  padding: 0;
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
